import { CONFIG } from '../../../config'

const { ENVIROMENT } = CONFIG
const BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/cte`

//Emissor CTe
export const urlEmissores = `${BASE_URL}/emissor`

export function urlGetEmissoresTpId(tpId) {
  if (tpId) return `${urlEmissores}/tps/?tp_id=${tpId}`

  return `${urlEmissores}/tps`
}

//CTe
export function urlGetCteTpId(tpId, pInicial, pFinal) {
  const params = []

  if (tpId) params.push(`tp_id=${tpId}`)
  if (pInicial) params.push(`pInicial=${pInicial}`)
  if (pFinal) params.push(`pFinal=${pFinal}`)

  if (params.length) return `${BASE_URL}?${params.join('&')}`

  return BASE_URL
}

export const urlDeleteCancelCte = `${BASE_URL}/cancel`
export function urlDownloadCte(ctes_id) {
  return `${BASE_URL}/download?ctes_id=${ctes_id}`
}

export const urlBaseCte = BASE_URL

// CTe Globalizado
export function urlGetDeliveriesForCteGlobalizado(tp_id, company_id, p_inicial, p_final) {
  return `${BASE_URL}/globalizado/deliveries?tp_id=${tp_id}&company_id=${company_id}&p_inicial=${p_inicial}&p_final=${p_final}`
}

export const urlCalcularFreteMultiplo = `${BASE_URL}/globalizado/calcular-frete`

export const urlEmitCteGlobalizado = `${BASE_URL}/globalizado`

// CTe Complementar
export const urlEmitCteComplementar = `${BASE_URL}/complementar`

export function urlRegrasFreteCteComplementar(cte_id) {
  return `${BASE_URL}/complementar/regras-frete?cte_id=${cte_id}`
}

// CTe de Substituição
export const urlEmitCteSubstituicao = `${BASE_URL}/substituicao`

export function urlDadosSubstituicaoCte(cte_id) {
  return `${BASE_URL}/substituicao/dados?cte_id=${cte_id}`
}

//CFOP
export const urlCfops = `${BASE_URL}/cfop`

// CTe sem Nota Fiscal 
export function urlEmitCteSemNota(tpId) {
  return `${BASE_URL}/sem-nota?tp_id=${tpId}`
}

export function urlGetParteCteSemNota(tpId, tipo, id) {
  return `${BASE_URL}/sem-nota/parte?tp_id=${tpId}&tipo=${tipo}&id=${id}`
}

export function urlGetClientesCteSemNota(tpId, term) {
  return `${BASE_URL}/sem-nota/clientes?tp_id=${tpId}&term=${encodeURIComponent(term || '')}`
}

// CTe de Subcontratação: CT-es de origem importados por XML
export function urlCtesOrigem(tpId, pInicial, pFinal) {
  return `${BASE_URL}/subcontratacao/origem?tp_id=${tpId}&pInicial=${pInicial}&pFinal=${pFinal}`
}

export function urlImportarCteOrigem(tpId) {
  return `${BASE_URL}/subcontratacao/origem?tp_id=${tpId}`
}

export function urlCteOrigem(tpId, id) {
  return `${BASE_URL}/subcontratacao/origem/${id}?tp_id=${tpId}`
}

export function urlXmlCteOrigem(tpId, id) {
  return `${BASE_URL}/subcontratacao/origem/${id}/xml?tp_id=${tpId}`
}

export function urlEmitCteSubcontratacao(tpId) {
  return `${BASE_URL}/subcontratacao?tp_id=${tpId}`
}
